import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { querySituationUser, querySituationPost, querySituationOrgan } from '@/api/notice/documentApi.js';
import { queryFormDetails } from '@/services/form';
export default {
  data: function data() {
    var columnOne = [{
      title: '成员姓名',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '成员电话',
      dataIndex: 'mobile',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '查阅时间',
      dataIndex: 'viewTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }];
    var columnTwo = [{
      title: '成员姓名',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '成员电话',
      dataIndex: 'mobile',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '组织名称',
      dataIndex: 'organName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '查阅时间',
      dataIndex: 'viewTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }];
    var columnThree = [{
      title: '成员姓名',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '成员电话',
      dataIndex: 'mobile',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '岗位名称',
      dataIndex: 'postName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '查阅时间',
      dataIndex: 'viewTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }];
    var columnList = {
      0: columnOne,
      1: columnTwo,
      2: columnThree
    };
    return {
      loading: false,
      expand: false,
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      readData: {},
      data: [],
      menuId: [0],
      referTypeId: 0,
      referType: [{
        cateId: 0,
        cateName: '查阅情况-按人员'
      }, {
        cateId: 1,
        cateName: '查阅情况-按组织'
      }, {
        cateId: 2,
        cateName: '查阅情况-按岗位'
      }],
      columnList: columnList,
      where: {
        mobile: '',
        query: '',
        docId: this.$route.query.id,
        typeId: ''
      },
      pagination: this.$hdk.page()
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var where = this.where;
  },
  methods: {
    /**
     * 查阅类型切换
     */
    menuClick: function menuClick(item) {
      this.referTypeId = item.key;
      // 切换数据置空
      this.where = {
        mobile: '',
        query: '',
        docId: this.$route.query.id,
        typeId: ''
      };
      this.fetch({
        current: 1,
        pageSize: 10
      });
    },
    /**
     * 查阅类型
     */
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        where = this.where,
        referTypeId = this.referTypeId,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }

      // 根据查阅类型查询相关类型
      if (referTypeId === 0) {
        querySituationUser(pager.current, pager.pageSize, pager.where).then(function (res) {
          _this.data = res.data.situation;
          _this.readData = res.data.proportion;
          _.assign(pagination, {
            total: res.data.count,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(where, pager.where);
        }).finally(function () {
          _this.loading = false;
        });
      } else if (referTypeId === 1) {
        querySituationOrgan(pager.current, pager.pageSize, pager.where).then(function (res) {
          _this.data = res.data.situation;
          _this.readData = res.data.proportion;
          _.assign(pagination, {
            total: res.data.count,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(where, pager.where);
        }).finally(function () {
          _this.loading = false;
        });
      } else if (referTypeId === 2) {
        querySituationPost(pager.current, pager.pageSize, pager.where).then(function (res) {
          _this.data = res.data.situation;
          _this.readData = res.data.proportion;
          _.assign(pagination, {
            total: res.data.count,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(where, pager.where);
        }).finally(function () {
          _this.loading = false;
        });
      }
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      this.$router.push({
        path: '/docNotice/doc/send'
      });
    }
  },
  computed: {
    columns: function columns() {
      return this.columnList[this.referTypeId];
    }
  }
};